import React, { useEffect, useRef, useState } from 'react';
import { copyText } from './hqApi';

export default function CopyButton({ getText, label = 'Copy', className = 'btn btn-sm btn-outline-secondary' }) {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const handleCopy = async () => {
        const text = typeof getText === 'function' ? getText() : getText;
        const ok = await copyText(text);
        if (ok) {
            setCopied(true);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <button type="button" className={className} onClick={handleCopy}>
            {copied ? (
                <>
                    <i className="fa-solid fa-check text-success me-1" aria-hidden="true"></i>
                    Copied
                </>
            ) : (
                <>
                    <i className="fa-regular fa-copy me-1" aria-hidden="true"></i>
                    {label}
                </>
            )}
        </button>
    );
}
